export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_REGEX = /^\(?([2-9][0-9]{2})\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})$/;
export const POSTAL_CODE_PREFIX_REGEX = /^[A-Za-z]\d[A-Za-z]$/i;

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const validators = {
  validateEmail: (email: string): ValidationResult => {
    if (!email.trim()) {
      return { isValid: false, error: 'Email is required' };
    }
    if (!EMAIL_REGEX.test(email.trim())) {
      return { isValid: false, error: 'Please enter a valid email address' };
    }
    return { isValid: true };
  },

  validatePhone: (phone: string): ValidationResult => {
    if (!phone.trim()) {
      return { isValid: false, error: 'Phone number is required' };
    }
    if (!PHONE_REGEX.test(phone.trim())) {
      return {
        isValid: false,
        error: 'Invalid phone number. Area code and exchange code cannot start with 0 or 1. Valid format: 555-555-5555',
      };
    }
    return { isValid: true };
  },

  validatePostalCode: (code: string): ValidationResult => {
    if (!code.trim()) {
      return { isValid: false, error: 'Postal code prefix is required' };
    }
    if (!POSTAL_CODE_PREFIX_REGEX.test(code.trim())) {
      return {
        isValid: false,
        error: 'Please enter a valid postal code prefix (e.g., A1A)',
      };
    }
    return { isValid: true };
  },

  isValidEmail: (email: string): boolean => {
    return EMAIL_REGEX.test(email.trim());
  },

  isValidPhone: (phone: string): boolean => {
    return PHONE_REGEX.test(phone.trim());
  },

  isValidPostalCode: (code: string): boolean => {
    return POSTAL_CODE_PREFIX_REGEX.test(code.trim());
  },
};
